import Alpine from "alpinejs";

export default ({ sectionId, collectionUrl }) => ({
	isLoading: false,
	requestToken: 0,

	init() {
		this.onPopState = () => this.applyFromUrl();
		window.addEventListener("popstate", this.onPopState);
	},

	destroy() {
		window.removeEventListener("popstate", this.onPopState);
	},

	toggle(input) {
		const params = this.currentParams();
		const { name, value, checked } = input;

		const existing = params.getAll(name).filter((v) => v !== value);
		params.delete(name);
		existing.forEach((v) => params.append(name, v));
		if (checked) params.append(name, value);

		this.apply(params);
	},

	clearAll() {
		const params = new URLSearchParams();
		const sortBy = this.currentParams().get("sort_by");
		if (sortBy) params.set("sort_by", sortBy);
		this.apply(params);
	},

	apply(paramsArg) {
		const params = paramsArg || this.paramsFromForm();
		const queryString = params.toString();
		const url = queryString ? `${collectionUrl}?${queryString}` : collectionUrl;

		window.history.pushState({}, "", url);
		return this.fetchAndSwap(url);
	},

	applyFromUrl() {
		return this.fetchAndSwap(window.location.href);
	},

	async fetchAndSwap(url) {
		const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
		if (!sectionEl) return;

		const fetchUrl = new URL(url, window.location.origin);
		fetchUrl.searchParams.set("section_id", sectionId);

		const myToken = ++this.requestToken;

		this.isLoading = true;
		sectionEl.setAttribute("aria-busy", "true");

		try {
			const response = await fetch(fetchUrl.toString());
			if (myToken !== this.requestToken) return;
			if (!response.ok) throw new Error(`Section fetch failed: ${response.status}`);

			const html = await response.text();
			if (myToken !== this.requestToken) return;

			Array.from(sectionEl.children).forEach((child) => Alpine.destroyTree(child));
			sectionEl.innerHTML = html;
			Array.from(sectionEl.children).forEach((child) => Alpine.initTree(child));
		} catch (err) {
			console.error(err);
		} finally {
			if (myToken === this.requestToken) {
				this.isLoading = false;
				sectionEl.removeAttribute("aria-busy");
			}
		}
	},

	currentParams() {
		return new URLSearchParams(window.location.search);
	},

	paramsFromForm() {
		const form = this.$refs.form;
		const data = new FormData(form);
		const params = new URLSearchParams();
		for (const [key, value] of data.entries()) {
			if (value === "" || value == null) continue;
			params.append(key, value);
		}
		return params;
	},
});
